@let item = notification();

<button
  type="button"
  data-test="notification"
  class="card-panel relative flex w-full items-start gap-3 rounded-2xl p-3 text-left transition-transform duration-100 ease-out active:scale-[0.99] motion-reduce:transition-none motion-reduce:active:scale-100"
  [class.opacity-60]="item.read"
  (click)="selected.emit(item)">
  <span
    aria-hidden="true"
    class="btn-secondary grid size-9 shrink-0 place-items-center rounded-full"
    [class]="kind().color">
    <icon
      [name]="kind().icon"
      [size]="18" />
  </span>

  <span class="min-w-0 flex-1">
    <span class="flex items-start gap-2">
      <span
        class="text-body flex-1 leading-snug"
        [class]="item.read ? 'text-blue-frost font-medium' : 'text-gold-cream font-bold'">
        {{ item.title }}
      </span>

      @if (!item.read) {
      <span
        aria-label="Sin leer"
        class="bg-gold-peach mt-1.5 size-2 shrink-0 rounded-full"></span>
      }
    </span>

    <span class="text-label text-blue-frost mt-1 block leading-snug">{{ item.description }}</span>

    <span class="text-caption text-blue-sky mt-2 block font-medium">{{ item.date | date: "d MMM yyyy · hh:mm a" }}</span>
  </span>
</button>
